import { AxiosInstance } from 'axios';
import { getExportConfig, handleFileExport } from '../../../../../../helpers/fileExport';
import {
  FORECAST_BY_ROOM_TYPE_COLUMNS_REPORT_ENDPOINT,
  FORECAST_BY_ROOM_TYPE_REPORT_ENDPOINT,
} from '../endpoint';
import { ForecastByRoomTypeReportRequestModel } from '../models/ForecastByRoomTypeReportRequestModel';

export const exportPDF =
  (axios: AxiosInstance) =>
  async (params?: ForecastByRoomTypeReportRequestModel): Promise<void> => {
    return await axios
      .get(`${FORECAST_BY_ROOM_TYPE_REPORT_ENDPOINT}`, {
        params: { ...params },
        ...getExportConfig(params),
      })
      .then(response => {
        handleFileExport(response, {
          file_type: params?.file_type,
          filename: 'forecast-by-room-type-report',
        });
      });
  };

export const getSettingsColumns =
  (axios: AxiosInstance) => async (): Promise<Record<string, string>> => {
    return await axios.get(`${FORECAST_BY_ROOM_TYPE_COLUMNS_REPORT_ENDPOINT}`).then(response => {
      return response.data as Record<string, string>;
    });
  };
